import React, { useState } from 'react';
import IconCode from '@/svgs/file-code.svg?react';
import Button from './Button';
import useTypedPage from '@/Hooks/useTypedPage';
import useRequests from '@/Hooks/useRequests';
import { Tooltip } from '@/Components/Tooltip';

export default function CreateSnippet({
  code,
  language,
}: {
  code: string;
  language?: string;
}) {
  const { post } = useRequests();
  const [loading, setLoading] = useState(false);
  const { conversation } = useTypedPage<{
    conversation: App.Data.ConversationData;
  }>().props;

  function handleCreateSnippetClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    post(
      'conversation.file.code',
      { conversation: conversation.id },
      {
        language,
        code,
      },
      {
        onBefore: () => setLoading(true),
        onFinish: () => setLoading(false),
      },
    );
  }

  return (
    <Tooltip message="Create a snippet">
      <Button onClick={handleCreateSnippetClick} pending={loading}>
        <IconCode className="h-4 w-4" />
      </Button>
    </Tooltip>
  );
}
